// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2FsmM","productName":"Table_productName__1iXox"};